module.exports = __webpack_public_path__ + "img/ARS_1247.7309fc40.jpg";